import React, { memo, useMemo } from 'react';

// helpers
import { StateModel } from '../../redux/reducers';
import { useSelector } from 'react-redux';
import { IApplication } from 'typings/application/applications';
import { OnboardingEntryTypes } from '../../enums/onboarding/crm';

// components
import Individual from '../../modules/Onboarding/Individual';
import Organization from '../../modules/Onboarding/Organization';
import StartOnboarding from 'modules/Onboarding/StartOnboarding';

const OnboardingPage = memo(() => {
  const activeApplication = useSelector<StateModel, IApplication | null>(
    (state) => state.applications.activeApplication,
  );

  const contentNode = useMemo(() => {
    if (!activeApplication) {
      return null;
    }

    if (
      activeApplication.clientIntakeSubmissionId &&
      !activeApplication.isOnboardingStarted
    ) {
      return <StartOnboarding />;
    }

    if (activeApplication.onboardingProcess?.type) {
      switch (activeApplication.onboardingProcess.type) {
        case OnboardingEntryTypes.Contact:
          return <Individual />;

        case OnboardingEntryTypes.Organization:
          return <Organization />;

        default:
          return null;
      }
    }
  }, [activeApplication]);

  return <>{contentNode}</>;
});

export default OnboardingPage;
